<template>

            <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                :disabled="readonly"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="date"
                    :label="label"
                    prepend-icon="fa-calendar-alt"
                    id="date"
                    name="date"
                    readonly
                    v-bind="attrs"
                    :v-validate="required ? 'required' : ''" 
                    :error-messages="errors.collect('date')" 
                    :data-vv-as="label"                                                 
                    v-on="on"
                ></v-text-field>
                </template>
                <v-date-picker v-model="date"  @input="menu = false" no-title scrollable locale="pl-PL" :readonly="readonly">
                </v-date-picker>
            </v-menu>             


</template>

<script>
export default {
    name: 'DatePicker',
    data () {
      return {
        date: this.value,
        menu: false,     
        label: this.pickerLabel
      }
    },
    props: ["value","pickerLabel","required","readonly"],
    watch: {
		date(val) {		            
			if(val) {			
                this.$emit('input',val)
				//document.body.style.background = val;
			}
        },
        value(val)
        {
            this.date = val
        }
    },
    
}
</script>

<style>

</style>
